import { Fetch } from 'lib';
import type { Role } from 'types';

type RequestResponses = Role;

type RequestParameters = {
  id: string;
};

const getRole = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminRole/getRole',
    params,
  });

export { getRole };
